import React from 'react';
import { useTranslation } from 'next-i18next';
import { Image, Link, LogoIcon } from '@/components';
import { PagePath } from '@/layouts/shared';
import { createHandle } from '@/libs/app';
import { ProductTypes } from '../chat/const';

/** Show only fields supplied by the existing product response. */
export const ProductSummary = ({ product }: { product: ProductTypes }) => {
  const { t } = useTranslation('layout');
  if (!product?.id) return null;
  const image = product.images?.[0]?.url || product.image;
  const handle = `${createHandle(product.product_name)}-${product.id}-${product.product_code}`;
  return (
    <div className="consult-product-summary">
      {image ? <Image src={image} alt={product.product_name || product.product_code} className="consult-summary-image" /> : <span className="consult-summary-image consult-summary-fallback"><LogoIcon width="56" height="24" /></span>}
      <div><strong>{product.product_name || product.product_code}</strong><p>{product.gem_material || product.cat_name || product.product_code}</p>
        <Link url={{ pathname: PagePath.ProductDetailPage, query: { id: handle } }} target="_blank">{t('consultPopup.viewProduct')} <span aria-hidden="true">↗</span></Link>
      </div>
    </div>
  );
};
